import React, { PureComponent } from "react";
import { connect } from "react-redux";
import PageHeaderWrapper from "../../components/PageHeaderWrapper";
import { Collapse, Card, Row, Col, Form, Button, Input, Drawer, notification } from 'antd'
import Request, { API_URL, LAPI_URL } from "../../request";
import _ from 'lodash'
import { FormUtils as GetAllFormFields } from 'sz-react-utils'
const { Panel } = Collapse


@Form.create()
class getHelp extends PureComponent {
    state = {
        activeKey: '',
        subCategoryKey: '',
        categories: [],
        selectedaCategories: [],
        selectedCountry: 0,
        selectedDocLinks: [],
        selectedCategory: '',
        search_title: '',
        showSupportDrawer: false,
        categoryForForm: [],
        selectedCategoryName: '',
        subCategoryForForm: [],
        selectedSubCategory: 0,
        selectedSubCategoryName: '',
        phoneCodes: [],
        showFormCategory: true,
        showFormSubCategory: true
    }
    onChange = (key) => {
        this.setState({ activeKey: key })
    };

    onSubCategoryChange = (key) => {
        this.setState({ subCategoryKey: key })
    }

    // handleSubmit = (e)=>{
    //     const {form,dispatch} = this.props;
    //     e.preventDefault()
    //     form.validateFieldsAndScroll((err,valData)=>{
    //         let values = _.clone(valData)
    //         if(this.state.activeKey === "1"){
    //             values.supportType = "Technical Support"
    //         }else if (this.state.activeKey === "2"){
    //             values.supportType = "Licensing and Billing Questions"
    //         }else if(this.state.activeKey === "3"){
    //             values.supportType = "Product Trial Questions"
    //         }else if(this.state.activeKey === "4"){
    //             values.supportType = "Other Questions"
    //         }else if(this.state.activeKey === "5"){
    //             values.supportType = "Report a Bug"
    //         }else if(this.state.activeKey === "6"){
    //             values.supportType = "New Service/Workflow"
    //         }else if(this.state.activeKey === "7"){
    //             values.supportType = "Suggest a New Feature"
    //         }else if(this.state.activeKey === "8"){
    //             values.supportType = "Customize CRM Functionalities"
    //         }
    //         console.log(values)
    //     })
    // }

    loadSubCategory = (categoryIndex) => {
        let categories = this.state.categories;
        let subCategoryForForm = []
        let selectedCategory = categories[categoryIndex - 1]
        _.each(selectedCategory, (subCategory, index) => {
            subCategoryForForm.push({ id: subCategory.name, display: subCategory.name })
        })
        this.setState({ selectedCategory })
    }

    handleSupportButton = () => {
        this.setState({ showSupportDrawer: true })
        // console.log(this.state.selectedCategoryName)
        setTimeout(() => {
            this.props.form.setFieldsValue({
                category: this.state.selectedCategoryName,
                subCategory: this.state.selectedSubCategoryName
            })
        }, 50)
    }

    getCats = (catIndex) => {
        this.setState({ selectedaCategories: [] });
        var getSupportCategories = this.state.categories;
        let innerCategories = getSupportCategories[catIndex];
        var selectedaCategories = [];
        let { subCategories } = innerCategories && innerCategories
        if (subCategories) {
            for (let i = 0; i < subCategories.length; i++) {
                selectedaCategories.push(subCategories[i])
            }
        }
        // for(let i=0; i<subCategories.length; i++) {
        //     selectedaCategories.push(subCategories[i])
        // }    
        this.setState({ selectedaCategories: selectedaCategories, selectedCountry: catIndex, selectedCategoryName: innerCategories.name }, () => {
            if (selectedaCategories && selectedaCategories.length > 0) {
                this.getDocs(catIndex, 0)
            }
        });
        if (!subCategories) {
            let faqs = getSupportCategories[catIndex].faqs
            if (faqs.length) {
                this.setState({ selectedDocLinks: getSupportCategories[catIndex].faqs, selectedCategory: '', showFormCategory: true, showFormSubCategory: false }, () => {
                    this.props.form.setFieldsValue({ subCategory: '' })
                })
            } else {
                this.setState({ selectedDocLinks: [], selectedCategory: '', showSupportDrawer: true, showFormCategory: false, showFormSubCategory: false })
            }
        } else if (!subCategories && !getSupportCategories[catIndex].faqs) {
            this.setState({ showSupportDrawer: true, selectedDocLinks: [], selectedCategory: '', showFormCategory: true, showFormSubCategory: true })
        }
        else {
            this.setState({ selectedDocLinks: [], selectedCategory: '', showFormCategory: true, showFormSubCategory: true });
        }

    }

    onClose = () => {
        this.setState({ showSupportDrawer: false })
        this.props.form.setFieldsValue({ category: '', subCategory: '' })
    }

    handleSubmit = (e) => {
        let { form, dispatch } = this.props
        e.preventDefault()
        form.validateFieldsAndScroll(async (err, valData) => {
            let values = _.clone(valData)
            let response = await Request.addSupportRequest(values)
            notification.success({
                message: response.message
            })
            this.onClose()
        })
    }
    getDocs = (catIndex, subCatIndex) => {
        this.setState({ docLinksHtml: [] });
        var getSupportCategories = this.state.categories;
        let innerLinks = getSupportCategories[catIndex].subCategories[subCatIndex];
        let { faqs } = innerLinks
        var selectedDocLinks = [];
        for (let i = 0; i < faqs.length; i++) {
            selectedDocLinks.push(faqs[i])
        }
        this.setState({ selectedDocLinks: selectedDocLinks, selectedCategory: subCatIndex, selectedSubCategoryName: innerLinks.name });
    }


    loadCountries = () => {
        let params = {
            results: 100,
            sortField: "countryName",
            sortOrder: "ascend",
        };
        Request.getCountriesWithoutAuth({ ...params }).then((resp) => {
            let phoneCodes = [];
            _.each(resp.data, (phone) => {
                phoneCodes.push({ id: phone.countryPhoneCode, display: phone.countryPhoneCode })
            })
            this.setState({ phoneCodes })
        }).catch((err) => {
            console.log(err)
        })
    }

    // loadCountries = () =>{
    //     let params = {
    //         results: 100,
    //         sortField: "countryName",
    //         sortOrder: "ascend",
    //       };
    //       Request.getCountriesWithoutAuth({ ...params }).then((resp) => {
    //         let countryFieldArr = [];
    //         let phoneCodes = [];
    //         let countryPhoneCodes = [];
    //         _.each(resp.data, (phone)=>{
    //             phoneCodes.push({id:phone.countryPhoneCode, display:phone.countryPhoneCode})
    //         })
    //         this.setState({phoneCodes})
    //         , []);
    //         // this.setState({ countryFieldArr: countryFieldArr, phoneCodes: phoneCodes, countryPhoneCodes: countryPhoneCodes });
    //       })
    //       .catch((err) => {
    //         console.log(err);
    //       });
    // } 

    async componentDidMount() {
        this.loadCountries()
        let response = await Request.getSupportFaqs()
        let categoryForForm = []
        let subCategoryForForm = []
        _.each(response.categories, (category, index) => {
            categoryForForm.push({ id: index + 1, display: category.name })
        })
        let { subCategories } = response.categories[0]
        if (subCategories.length > 0) {
            _.each(subCategories, (subCategory, index) => {
                subCategoryForForm.push({ id: index + 1, display: subCategory.name })
            })
        }

        this.setState({ categories: response.categories, selectedCategory: response.categories[0], categoryForForm, subCategoryForForm }, () => {
            this.getCats(0);
        })
    }

    render() {
        var getSupportCategories = this.state.categories
        var countriesHtml = [];
        var categoryHtml = [];
        var faqLinkHtml = [];
        for (let i = 0; i < getSupportCategories.length; i++) {
            countriesHtml.push(
                <button className={'tablinks ' + (this.state.selectedCountry === i ? 'active' : '')} key={getSupportCategories[i].id} onClick={() => this.getCats(i)}>
                    {/* <img src={countryFlag} className="countryFlag" alt='country Flag' /> */}
                    {getSupportCategories[i].name}
                </button>)
        }

        var selectedaCategories = this.state.selectedaCategories;
        for (let j = 0; j < selectedaCategories.length; j++) {
            let selectedaCategory = selectedaCategories[j]
            categoryHtml.push(<button key={j} className={'tablinks ' + (this.state.selectedCategory === j ? 'active' : '')} onClick={() => this.getDocs(this.state.selectedCountry, j)}>{selectedaCategory.name}</button>);
        }

        let selectedDocLinks = this.state.selectedDocLinks;
        for (let k = 0; k < selectedDocLinks.length; k++) {
            selectedDocLinks[k].post_content = selectedDocLinks[k].post_content.replace(new RegExp("[&#39;]", "g"), "'");
            faqLinkHtml.push(
                <Panel header={selectedDocLinks[k].post_title} key={k + 1}>
                    {
                        selectedDocLinks[k].post_content = selectedDocLinks[k].post_content.replace(/(<p[^>]+?>|<p>|<\/p>)/img, "")
                    }
                    {/* <p>{selectedDocLinks[k].post_content}</p>                 */}
                </Panel>
            )
        }


        const { categories, search_title, phoneCodes, showFormCategory, showFormSubCategory } = this.state
        let windowHeight = (window.innerHeight);
        const {
            form: { getFieldDecorator, getFieldValue, setFieldsValue }
        } = this.props

        let inputTypes = {
            fields: [
                {
                    label: 'Name',
                    key: 'name',
                    type: 'text',
                    required: true
                },
                {
                    label: 'Email',
                    key: 'email',
                    type: 'email',
                    required: true
                },
                {
                    label: 'Country Code',
                    key: 'countryCode',
                    type: 'select',
                    required: true,
                    options: phoneCodes,
                    onChange: v => {
                        setFieldsValue({ countryCode: v })
                    }
                },
                {
                    label: 'Phone Number',
                    key: 'phone',
                    type: 'text',
                    required: true
                },
                {
                    label: 'Category',
                    key: 'category',
                    type: 'select',
                    required: showFormCategory,
                    hidden: !showFormCategory,
                    options: this.state.categoryForForm,
                    onChange: v => {
                        setFieldsValue({ category: v })
                        this.loadSubCategory(v)
                    }
                },
                {
                    label: 'Sub Category',
                    key: 'subCategory',
                    type: 'select',
                    required: showFormSubCategory,
                    hidden: !showFormSubCategory,
                    options: this.state.subCategoryForForm,
                    onChange: v => {
                        setFieldsValue({ subCategory: v })
                    }
                },
                {
                    label: 'Description',
                    key: 'description',
                    type: 'textarea',
                    Row: 5,
                    required: true,
                },
                {
                    label: 'Attachment',
                    key: 'attachment',
                    limit: 5,
                    type: 'file',
                    required: true,
                },
            ]
        }

        const text = `
            A dog is a type of domesticated animal.
            Known for its loyalty and faithfulness,
            it can be found:a welcome guest in many households across the world.
            `;

        return (
            <PageHeaderWrapper title={`Get Support`}>
                <Card bordered={true}>
                    <div className="knowledgebase-tab-outer">
                        <div className="knowledgebase-tab tab" style={{ height: (windowHeight) + 'px' }}>
                            {/* <button className="default-country-name">Categories</button> */}
                            {countriesHtml}
                        </div>
                        <div id="London" className="knowledgebase-tabcontent tabcontent active">
                            {categoryHtml.length > 0 ? <div className="knowledgebase-tab tab" style={{ height: (windowHeight) + 'px' }}>
                                {/* <button className="default-category-name">Select Sub-Category</button> */}
                                {categoryHtml}
                            </div> : ''}
                            <div id="London-inner" className="knowledgebase-tabcontent-inner tabcontent active" style={{ height: windowHeight + 'px' }}>
                                <div style={{ display: 'flex', width: '100%', justifyContent: 'space-between' }}>
                                    <div style={{ width: "80%" }}>
                                        <Input
                                            value={search_title}
                                            placeholder={'Search by Title'}
                                            onChange={ei => {
                                                this.setState({
                                                    search_title: ei.target.value
                                                })
                                            }}
                                        />
                                    </div>
                                    <Button style={{ width: '18%', background: '#7ec365', color: '#FFFFF' }} onClick={this.handleSupportButton}>Get Support</Button>
                                </div>
                                <Collapse onChange={this.onChange} style={{ marginTop: 10 }}>
                                    {faqLinkHtml}
                                </Collapse>
                            </div>
                        </div>
                    </div>
                </Card>
                <Drawer
                    title={`Support`}
                    placement="right"
                    closable={true}
                    onClose={this.onClose}
                    visible={this.state.showSupportDrawer}
                    width={500}>
                    <Card>
                        <Form onSubmit={this.handleSubmit}>
                            <GetAllFormFields inputSchema={inputTypes} getFieldDecorator={getFieldDecorator} apiurl={LAPI_URL} />
                            <Col span={4}>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    style={{ marginBottom: 10 }}
                                    loading={this.props.loading}>
                                    Save
                                </Button>
                            </Col>
                        </Form>
                    </Card>
                </Drawer>
            </PageHeaderWrapper>
        )
    }
}



const mapStateToProps = ({ global, router }) => ({
    loading: global.buttonLoading,
    categories: global.categories,
    search: router.location.search
})

const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(getHelp)